export const loadWidget = (
  event: string,
  target: string,
  propsFn?: () => Node
) => {
  return new Promise((resolve, reject) => {
    const container = document.getElementById(target);
    const script = document.createElement("script");
    const div = document.createElement("div");
    div.setAttribute(event, "");
    script.setAttribute("src", process.env.WIDGET_SDK_URL || "");
    script.setAttribute("type", "module");
    script.setAttribute("defer", "");
    const react = document.createElement("script");
    react.setAttribute(
      "src",
      "https://www.unpkg.com/react@18.3.1/umd/react.production.min.js"
    );
    const reactDom = document.createElement("script");
    reactDom.setAttribute(
      "src",
      "https://www.unpkg.com/react-dom@18.3.1/umd/react-dom.production.min.js"
    );
    if (container !== null) {
      container.append(div);
      propsFn && container.append(propsFn());
      container.append(react);
      container.append(reactDom);
      container.appendChild(script);
    }
    script.onload = function() {
      resolve(true);
    };
    script.onerror = function() {
      reject(new Error(`Script loading error`));
    };
  });
};

export const addCTAForRibbonWidget = (label: string) => {
  const element = document.querySelector(
    ".match-ribbon-widget-mobile > div > div > div > span > div > span + div"
  );
  if (element) {
    const btnWrap = document.createElement("div");
    btnWrap.classList.add("ribbon-widget-cta");
    btnWrap.setAttribute(
      "style",
      `
      display: inline-flex;
      padding: 0 8px;
      margin: 0 15px;
      background-color: #000037;
      border-radius: 999px;
    `
    );
    const btn = document.createElement("a");
    btn.setAttribute(
      "href",
      "https://www.itftennis.com/en/world-tennis-tour-live/"
    );
    btn.textContent = label;
    btn.setAttribute(
      "style",
      `
      padding: 10px 10px 12px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
    `
    );
    const arrow = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    arrow.setAttribute("width", "14");
    arrow.setAttribute("height", "14");
    arrow.setAttribute("viewBox", "0 0 16 16");
    const arrowPath = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    arrowPath.setAttribute(
      "d",
      "M8 -3.49691e-07L6.59 1.41L12.17 7L-3.93402e-07 7L-3.0598e-07 9L12.17 9L6.58 14.58L8 16L16 8L8 -3.49691e-07Z"
    );
    arrowPath.setAttribute("fill", "white");
    arrow.appendChild(arrowPath);
    btn.appendChild(arrow);
    btnWrap.appendChild(btn);
    element.prepend(btnWrap);
  }
};

export const removeDesktopOnlyForRibbonWidget = () => {
  const list = document.getElementsByClassName("itf-tour");
  let pageSection;
  for (let i = 0; i < list.length; i++) {
    let next = list[i].nextElementSibling;
    if (next && next.classList.contains("page-section")) {
      pageSection = next;
      break;
    }
  }
  if (pageSection) {
    const widget = pageSection.querySelector('[data-desktop-only="true"]');
    if (widget) {
      widget.removeAttribute("data-desktop-only");
    }
  }
};
